import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {Search, Menu, X} from 'lucide-react'

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#00E5FF]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="w-8 h-8 bg-gradient-to-br from-[#00E5FF] to-[#FF006E] rounded-lg flex items-center justify-center transform group-hover:rotate-6 transition-transform">
              <span className="text-white font-bold text-xl">足</span>
            </div>
            <span className="text-white font-bold text-xl tracking-tight">
              Footprint <span className="text-[#00E5FF]">Tokyo</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/hipster-districts" className="text-gray-300 hover:text-[#00E5FF] transition-colors font-medium">
              Hipster Districts
            </Link>
            <Link to="/weird-tokyo" className="text-gray-300 hover:text-[#FF006E] transition-colors font-medium">
              Weird Tokyo
            </Link>
            <Link to="/logistics" className="text-gray-300 hover:text-white transition-colors font-medium">
              Logistics
            </Link>
            <Link to="/nightlife" className="text-gray-300 hover:text-[#FF006E] transition-colors font-medium">
              Nightlife
            </Link>
            <button className="text-gray-300 hover:text-[#00E5FF] transition-colors">
              <Search className="w-5 h-5" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#1A1A1A] border-t border-[#00E5FF]/20">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/hipster-districts"
              className="block text-gray-300 hover:text-[#00E5FF] transition-colors font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Hipster Districts
            </Link>
            <Link
              to="/weird-tokyo"
              className="block text-gray-300 hover:text-[#FF006E] transition-colors font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Weird Tokyo
            </Link>
            <Link
              to="/logistics"
              className="block text-gray-300 hover:text-white transition-colors font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Logistics
            </Link>
            <Link
              to="/nightlife"
              className="block text-gray-300 hover:text-[#FF006E] transition-colors font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Nightlife
            </Link>
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navigation
